import React, { Component } from 'react'

class Maintenance extends Component {
  render () {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'grid',
          placeItems: 'center',
          alignItems: 'center',
          alignContent: 'center'
        }}>
        <h3 style={{ width: '700px' }}>
          Sorry for the inconvenience. We are performing some maintenance and
          not able to promise an ETA. For urgency, you can always{' '}
          <a style={{ color: 'blue' }} href='mailto:chatrelonline@tibet.net'>
            contact us
          </a>
          , otherwise we&rsquo;ll be back soon. ཐུགས་རྗེ་ཆེ། 🙏
        </h3>
        <p>&mdash; TCRC, Central Tibetan Administration (5th Jan, 2025)</p>
      </div>
    )
  }
}

export default Maintenance
